<template>
	<div>
		<div class="btn1">
			<div class="jiams tj">
				<div>选择分类等级：</div>
				<Select v-model="query.typeGrade" style="width:300px"filterable='true' @on-change="onchangeSousuo">
				        <Option  value="1" >一级分类</Option>
						<Option  value="2" >二级分类</Option>
						<Option  value="3" >三级分类</Option>
				</Select>
			</div>
			<div class="jiams tj">
				<div>请选择设备：</div>
				<Select v-model="query.macIds" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo">
				        <Option v-for="item in macs" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</div>
			<div class="time tj">
				<div>选择年月：</div>
				<div class="time-xz">
					<DatePicker type="month" v-model="shijian" placeholder="开始时间" style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"  ></DatePicker>
					
				</div>
			</div>
			<div class="time tj">
				<div>排序方式：</div>
				<RadioGroup v-model="disabledGroup" @on-change="onchange">
				        <Radio label="销量"></Radio>
				        <Radio label="销售额"></Radio>
				    </RadioGroup>
			</div>
			
			<Button type="info" @click="daochu">导出</Button>
		</div>
		<div class="btn1">
			<Tag size="large" color="primary">总金额：{{totalMoney.toFixed(2)}}</Tag>
			<Tag size="large" color="primary">总销量：{{totalNumber}}</Tag>
		</div>
		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
				
			</template>
		</Table>
		<!-- <div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div> -->
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				disabledGroup:'销量',
				//设备列表
				macs: [
						/* {
							value: '1',
							label: 'New York'
						} */
					],
				//总页数
				total: 100,
				columns12: [{
						title: 'id',
						key: 'typeId',
						width:180,
						align:'center',
					},
					{
						title: '类型名称',
						key: 'typeName',
						width:240,
						align:'center',
					},
					
					{
						title: '销量',
						key: 'number',
						width:240,
						align:'center',
					},
					{
						title: '销量占比',
						key: 'ratioNumber',
						width:220,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.ratioNumber)
						}
					},
					{
						title: '销售额',
						key: 'money',
						width:200,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.money)
						}
					},
					{
						title: '销售额占比',
						key: 'ratioMoney',
						width:200,
						align:'center',
						render: (h, params) => {
							return h("div",params.row.ratioMoney)
						}
					}
				],
				data6: [
				],
				list1:[],
				list2:[],
				query: {
					macIds:[],//设备信息id
					year:2020,
					month:9,
					typeGrade:'1'
				},
				shijian:'',
				map:{
					weChatMoney:0,
					alipayMoney:0,
					meituanMoney:0,
					elmMoney:0,
					refundMoney:0
				},
				isDc:true,
				data61:[],
				columns121:[],
				totalNumber:0,
				totalMoney:0,
				loading:false
			}
		},
		methods: {
			
			onchange(a){
				console.log(a)
				if(a=='销售额'){
					this.data6=this.list1
				}else{
					this.data6=this.list2
				}
			},
			daochu(){
				let _this=this
				_this.$refs.selection.exportCsv({
					
				});
				 
			},
			//查询条件
			onchangeKaishi(time){
				let _this=this
				console.log(time)
				_this.query.year=time.split("-")[0]
				_this.query.month=time.split("-")[1]
				_this.ajaxPage()
			},
			onok(){
				let _this=this
				
				_this.ajaxPage()
			},
			onclear(){
				let _this=this
				_this.ajaxPage()
			},
			onchangeSousuo(){
				
				let _this=this
				_this.query.page=0
				_this.ajaxPage()
			},
			//查询条件
			aisle(row) { //货道药品信息
				this.$router.push({
					name: 'oper/mac/aisle/list',
					query: {
						id: row.id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				
				_this.totalMoney=0
				_this.totalNumber=0
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/comm/oper/type/operCommTongji',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.list1 = data.list1
						_this.list2 = data.list2
						_this.totalMoney=data.totalMoney
						_this.totalNumber=data.totalNumber
						_this.loading = false
						if(_this.totalMoney!=0){
							for (let i = 0; i < _this.list1.length; i++) {
								
								_this.list1[i].ratioNumber=(_this.list1[i].number/_this.totalNumber*100).toFixed(2)+"%"
								_this.list1[i].ratioMoney=(_this.list1[i].money/_this.totalMoney*100).toFixed(2)+"%"
							}
							for (let i = 0; i < _this.list2.length; i++) {
								_this.list2[i].ratioNumber=(_this.list2[i].number/_this.totalNumber*100).toFixed(2)+"%"
								_this.list2[i].ratioMoney=(_this.list2[i].money/_this.totalMoney*100).toFixed(2)+"%"
							}
						}
						
						 _this.data6=data.list2
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			
			queryMacs(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/oper',
				    data: {page:0,size:1000},
					_this: _this,
					success: function(data) {
						let items = data.macFaultDetailss.content
						for (let i = 0; i < items.length; i++) {
							let a={
								value: '',
								label: ''
							}
							a.value=items[i].id
							a.label=items[i].id+"-"+items[i].address
							_this.macs.push(a)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			}
		},
		components: {
			page
		},
		created() {
			var date = new Date();
			let year=parseInt(date.getFullYear()); //获取完整的年份(4位)
			let month=parseInt(date.getMonth())+1; //获取当前月份(0-11,0代表1月)
			let day=parseInt(date.getDate()); //获取当前日(1-31)
			this.shijian=year+"-"+month
			
			this.query.year=year
			this.query.month=month
			this.ajaxPage()
			this.queryMacs()
		},
		
		//修改首页的meta值，false时再次进入页面会重新请求数据。
		// beforeRouteLeave(to, from, next) {
		// 	from.meta.keepAlive = false;
		// 	next();
		// },
	}
</script>
<style scoped="scoped" lang="less">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.tongji {
		display: flex;
		margin:10px;
		.item{
		    margin: 0px 20px 0px 20px;
			display: flex;
			font-size: 20px;
		}
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn1 {
		margin: 20px 0;
		display: flex;
		justify-content: flex-start;
		.tj{
			display: flex;
			align-items: center;
		}
		.time{
			display: flex;
			.time-xz{
				display: flex;
			    align-items: center;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/finance/tongji/commTypeList.vue